export default [
    {
    id: 274477665,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzQ0Nzc2NjU=",
    name: "Dancewebsite",
    full_name: "maqbull/Dancewebsite",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/Dancewebsite",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/maqbull/Dancewebsite",
    forks_url: "https://api.github.com/repos/maqbull/Dancewebsite/forks",
    keys_url: "https://api.github.com/repos/maqbull/Dancewebsite/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/Dancewebsite/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/Dancewebsite/teams",
    hooks_url: "https://api.github.com/repos/maqbull/Dancewebsite/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/Dancewebsite/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/Dancewebsite/events",
    assignees_url: "https://api.github.com/repos/maqbull/Dancewebsite/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/Dancewebsite/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/Dancewebsite/tags",
    blobs_url: "https://api.github.com/repos/maqbull/Dancewebsite/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/Dancewebsite/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/Dancewebsite/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/Dancewebsite/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/Dancewebsite/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/Dancewebsite/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/Dancewebsite/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/Dancewebsite/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/Dancewebsite/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/Dancewebsite/subscription",
    commits_url: "https://api.github.com/repos/maqbull/Dancewebsite/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/Dancewebsite/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/Dancewebsite/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/Dancewebsite/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/Dancewebsite/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/Dancewebsite/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/Dancewebsite/merges",
    archive_url: "https://api.github.com/repos/maqbull/Dancewebsite/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/Dancewebsite/downloads",
    issues_url: "https://api.github.com/repos/maqbull/Dancewebsite/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/Dancewebsite/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/Dancewebsite/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/Dancewebsite/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/Dancewebsite/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/Dancewebsite/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/Dancewebsite/deployments",
    created_at: "2020-06-23T18:17:19Z",
    updated_at: "2021-04-21T21:31:41Z",
    pushed_at: "2020-12-06T15:06:44Z",
    git_url: "git://github.com/maqbull/Dancewebsite.git",
    ssh_url: "git@github.com:maqbull/Dancewebsite.git",
    clone_url: "https://github.com/maqbull/Dancewebsite.git",
    svn_url: "https://github.com/maqbull/Dancewebsite",
    homepage: null,
    size: 914,
    stargazers_count: 2,
    watchers_count: 2,
    language: "Pug",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 2,
    default_branch: "master"
    },
    {
    id: 274739522,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzQ3Mzk1MjI=",
    name: "designpage.github.io",
    full_name: "maqbull/designpage.github.io",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/designpage.github.io",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/maqbull/designpage.github.io",
    forks_url: "https://api.github.com/repos/maqbull/designpage.github.io/forks",
    keys_url: "https://api.github.com/repos/maqbull/designpage.github.io/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/designpage.github.io/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/designpage.github.io/teams",
    hooks_url: "https://api.github.com/repos/maqbull/designpage.github.io/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/designpage.github.io/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/designpage.github.io/events",
    assignees_url: "https://api.github.com/repos/maqbull/designpage.github.io/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/designpage.github.io/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/designpage.github.io/tags",
    blobs_url: "https://api.github.com/repos/maqbull/designpage.github.io/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/designpage.github.io/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/designpage.github.io/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/designpage.github.io/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/designpage.github.io/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/designpage.github.io/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/designpage.github.io/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/designpage.github.io/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/designpage.github.io/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/designpage.github.io/subscription",
    commits_url: "https://api.github.com/repos/maqbull/designpage.github.io/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/designpage.github.io/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/designpage.github.io/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/designpage.github.io/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/designpage.github.io/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/designpage.github.io/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/designpage.github.io/merges",
    archive_url: "https://api.github.com/repos/maqbull/designpage.github.io/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/designpage.github.io/downloads",
    issues_url: "https://api.github.com/repos/maqbull/designpage.github.io/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/designpage.github.io/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/designpage.github.io/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/designpage.github.io/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/designpage.github.io/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/designpage.github.io/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/designpage.github.io/deployments",
    created_at: "2020-06-24T18:19:25Z",
    updated_at: "2020-06-24T18:30:42Z",
    pushed_at: "2020-06-24T18:30:39Z",
    git_url: "git://github.com/maqbull/designpage.github.io.git",
    ssh_url: "git@github.com:maqbull/designpage.github.io.git",
    clone_url: "https://github.com/maqbull/designpage.github.io.git",
    svn_url: "https://github.com/maqbull/designpage.github.io",
    homepage: null,
    size: 11,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: "master"
    },
    {
    id: 323387161,
    node_id: "MDEwOlJlcG9zaXRvcnkzMjMzODcxNjE=",
    name: "instabot",
    full_name: "maqbull/instabot",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/instabot",
    description: "Instabot which follow",
    fork: false,
    url: "https://api.github.com/repos/maqbull/instabot",
    forks_url: "https://api.github.com/repos/maqbull/instabot/forks",
    keys_url: "https://api.github.com/repos/maqbull/instabot/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/instabot/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/instabot/teams",
    hooks_url: "https://api.github.com/repos/maqbull/instabot/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/instabot/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/instabot/events",
    assignees_url: "https://api.github.com/repos/maqbull/instabot/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/instabot/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/instabot/tags",
    blobs_url: "https://api.github.com/repos/maqbull/instabot/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/instabot/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/instabot/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/instabot/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/instabot/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/instabot/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/instabot/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/instabot/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/instabot/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/instabot/subscription",
    commits_url: "https://api.github.com/repos/maqbull/instabot/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/instabot/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/instabot/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/instabot/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/instabot/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/instabot/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/instabot/merges",
    archive_url: "https://api.github.com/repos/maqbull/instabot/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/instabot/downloads",
    issues_url: "https://api.github.com/repos/maqbull/instabot/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/instabot/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/instabot/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/instabot/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/instabot/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/instabot/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/instabot/deployments",
    created_at: "2020-12-21T16:14:23Z",
    updated_at: "2020-12-21T16:14:23Z",
    pushed_at: "2020-12-21T16:14:24Z",
    git_url: "git://github.com/maqbull/instabot.git",
    ssh_url: "git@github.com:maqbull/instabot.git",
    clone_url: "https://github.com/maqbull/instabot.git",
    svn_url: "https://github.com/maqbull/instabot",
    homepage: null,
    size: 0,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 5,
    open_issues: 0,
    watchers: 0,
    default_branch: "main"
    },
    {
    id: 345616638,
    node_id: "MDEwOlJlcG9zaXRvcnkzNDU2MTY2Mzg=",
    name: "JSONServer",
    full_name: "maqbull/JSONServer",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/JSONServer",
    description: "JSON server file for my project PET- STORE",
    fork: false,
    url: "https://api.github.com/repos/maqbull/JSONServer",
    forks_url: "https://api.github.com/repos/maqbull/JSONServer/forks",
    keys_url: "https://api.github.com/repos/maqbull/JSONServer/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/JSONServer/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/JSONServer/teams",
    hooks_url: "https://api.github.com/repos/maqbull/JSONServer/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/JSONServer/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/JSONServer/events",
    assignees_url: "https://api.github.com/repos/maqbull/JSONServer/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/JSONServer/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/JSONServer/tags",
    blobs_url: "https://api.github.com/repos/maqbull/JSONServer/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/JSONServer/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/JSONServer/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/JSONServer/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/JSONServer/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/JSONServer/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/JSONServer/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/JSONServer/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/JSONServer/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/JSONServer/subscription",
    commits_url: "https://api.github.com/repos/maqbull/JSONServer/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/JSONServer/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/JSONServer/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/JSONServer/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/JSONServer/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/JSONServer/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/JSONServer/merges",
    archive_url: "https://api.github.com/repos/maqbull/JSONServer/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/JSONServer/downloads",
    issues_url: "https://api.github.com/repos/maqbull/JSONServer/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/JSONServer/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/JSONServer/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/JSONServer/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/JSONServer/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/JSONServer/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/JSONServer/deployments",
    created_at: "2021-03-08T10:27:00Z",
    updated_at: "2021-03-08T10:27:03Z",
    pushed_at: "2021-03-08T11:37:45Z",
    git_url: "git://github.com/maqbull/JSONServer.git",
    ssh_url: "git@github.com:maqbull/JSONServer.git",
    clone_url: "https://github.com/maqbull/JSONServer.git",
    svn_url: "https://github.com/maqbull/JSONServer",
    homepage: null,
    size: 275,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main"
    },
    {
    id: 342842712,
    node_id: "MDEwOlJlcG9zaXRvcnkzNDI4NDI3MTI=",
    name: "my-mail",
    full_name: "maqbull/my-mail",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/my-mail",
    description: "Its a React App which is showing 2000 Mails at great speed , Notification is also arriving when mail added",
    fork: false,
    url: "https://api.github.com/repos/maqbull/my-mail",
    forks_url: "https://api.github.com/repos/maqbull/my-mail/forks",
    keys_url: "https://api.github.com/repos/maqbull/my-mail/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/my-mail/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/my-mail/teams",
    hooks_url: "https://api.github.com/repos/maqbull/my-mail/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/my-mail/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/my-mail/events",
    assignees_url: "https://api.github.com/repos/maqbull/my-mail/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/my-mail/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/my-mail/tags",
    blobs_url: "https://api.github.com/repos/maqbull/my-mail/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/my-mail/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/my-mail/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/my-mail/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/my-mail/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/my-mail/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/my-mail/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/my-mail/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/my-mail/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/my-mail/subscription",
    commits_url: "https://api.github.com/repos/maqbull/my-mail/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/my-mail/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/my-mail/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/my-mail/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/my-mail/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/my-mail/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/my-mail/merges",
    archive_url: "https://api.github.com/repos/maqbull/my-mail/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/my-mail/downloads",
    issues_url: "https://api.github.com/repos/maqbull/my-mail/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/my-mail/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/my-mail/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/my-mail/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/my-mail/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/my-mail/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/my-mail/deployments",
    created_at: "2021-02-27T11:40:54Z",
    updated_at: "2021-03-08T12:59:33Z",
    pushed_at: "2021-02-27T11:59:23Z",
    git_url: "git://github.com/maqbull/my-mail.git",
    ssh_url: "git@github.com:maqbull/my-mail.git",
    clone_url: "https://github.com/maqbull/my-mail.git",
    svn_url: "https://github.com/maqbull/my-mail",
    homepage: "https://maqbull.github.io/my-mail/",
    size: 375,
    stargazers_count: 1,
    watchers_count: 1,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "gh-pages"
    },
    {
    id: 340928674,
    node_id: "MDEwOlJlcG9zaXRvcnkzNDA5Mjg2NzQ=",
    name: "Pet-Store",
    full_name: "maqbull/Pet-Store",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/Pet-Store",
    description: "This is a Pet-Store website where we can adopt a pet or add a pet and edit pet-name or like anything .",
    fork: false,
    url: "https://api.github.com/repos/maqbull/Pet-Store",
    forks_url: "https://api.github.com/repos/maqbull/Pet-Store/forks",
    keys_url: "https://api.github.com/repos/maqbull/Pet-Store/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/Pet-Store/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/Pet-Store/teams",
    hooks_url: "https://api.github.com/repos/maqbull/Pet-Store/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/Pet-Store/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/Pet-Store/events",
    assignees_url: "https://api.github.com/repos/maqbull/Pet-Store/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/Pet-Store/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/Pet-Store/tags",
    blobs_url: "https://api.github.com/repos/maqbull/Pet-Store/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/Pet-Store/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/Pet-Store/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/Pet-Store/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/Pet-Store/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/Pet-Store/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/Pet-Store/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/Pet-Store/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/Pet-Store/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/Pet-Store/subscription",
    commits_url: "https://api.github.com/repos/maqbull/Pet-Store/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/Pet-Store/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/Pet-Store/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/Pet-Store/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/Pet-Store/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/Pet-Store/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/Pet-Store/merges",
    archive_url: "https://api.github.com/repos/maqbull/Pet-Store/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/Pet-Store/downloads",
    issues_url: "https://api.github.com/repos/maqbull/Pet-Store/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/Pet-Store/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/Pet-Store/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/Pet-Store/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/Pet-Store/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/Pet-Store/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/Pet-Store/deployments",
    created_at: "2021-02-21T15:02:54Z",
    updated_at: "2021-04-21T21:31:20Z",
    pushed_at: "2021-03-08T12:46:54Z",
    git_url: "git://github.com/maqbull/Pet-Store.git",
    ssh_url: "git@github.com:maqbull/Pet-Store.git",
    clone_url: "https://github.com/maqbull/Pet-Store.git",
    svn_url: "https://github.com/maqbull/Pet-Store",
    homepage: "https://pets-store-maqbool.herokuapp.com/",
    size: 1909,
    stargazers_count: 2,
    watchers_count: 2,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 2,
    default_branch: "gh-pages"
    },
    {
    id: 346333314,
    node_id: "MDEwOlJlcG9zaXRvcnkzNDYzMzMzMTQ=",
    name: "portfolio",
    full_name: "maqbull/portfolio",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/portfolio",
    description: "my portfolio website",
    fork: true,
    url: "https://api.github.com/repos/maqbull/portfolio",
    forks_url: "https://api.github.com/repos/maqbull/portfolio/forks",
    keys_url: "https://api.github.com/repos/maqbull/portfolio/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/portfolio/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/portfolio/teams",
    hooks_url: "https://api.github.com/repos/maqbull/portfolio/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/portfolio/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/portfolio/events",
    assignees_url: "https://api.github.com/repos/maqbull/portfolio/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/portfolio/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/portfolio/tags",
    blobs_url: "https://api.github.com/repos/maqbull/portfolio/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/portfolio/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/portfolio/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/portfolio/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/portfolio/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/portfolio/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/portfolio/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/portfolio/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/portfolio/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/portfolio/subscription",
    commits_url: "https://api.github.com/repos/maqbull/portfolio/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/portfolio/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/portfolio/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/portfolio/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/portfolio/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/portfolio/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/portfolio/merges",
    archive_url: "https://api.github.com/repos/maqbull/portfolio/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/portfolio/downloads",
    issues_url: "https://api.github.com/repos/maqbull/portfolio/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/portfolio/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/portfolio/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/portfolio/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/portfolio/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/portfolio/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/portfolio/deployments",
    created_at: "2021-03-10T11:32:27Z",
    updated_at: "2021-03-14T11:55:04Z",
    pushed_at: "2021-03-14T11:50:33Z",
    git_url: "git://github.com/maqbull/portfolio.git",
    ssh_url: "git@github.com:maqbull/portfolio.git",
    clone_url: "https://github.com/maqbull/portfolio.git",
    svn_url: "https://github.com/maqbull/portfolio",
    homepage: "https://maqbull.github.io/portfolio/",
    size: 2584,
    stargazers_count: 1,
    watchers_count: 1,
    language: "HTML",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
    key: "mit",
    name: "MIT License",
    spdx_id: "MIT",
    url: "https://api.github.com/licenses/mit",
    node_id: "MDc6TGljZW5zZTEz"
    },
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master"
    },
    {
    id: 322024854,
    node_id: "MDEwOlJlcG9zaXRvcnkzMjIwMjQ4NTQ=",
    name: "quizapp",
    full_name: "maqbull/quizapp",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/quizapp",
    description: "Vue JS based quiz app",
    fork: false,
    url: "https://api.github.com/repos/maqbull/quizapp",
    forks_url: "https://api.github.com/repos/maqbull/quizapp/forks",
    keys_url: "https://api.github.com/repos/maqbull/quizapp/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/quizapp/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/quizapp/teams",
    hooks_url: "https://api.github.com/repos/maqbull/quizapp/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/quizapp/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/quizapp/events",
    assignees_url: "https://api.github.com/repos/maqbull/quizapp/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/quizapp/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/quizapp/tags",
    blobs_url: "https://api.github.com/repos/maqbull/quizapp/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/quizapp/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/quizapp/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/quizapp/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/quizapp/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/quizapp/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/quizapp/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/quizapp/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/quizapp/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/quizapp/subscription",
    commits_url: "https://api.github.com/repos/maqbull/quizapp/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/quizapp/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/quizapp/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/quizapp/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/quizapp/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/quizapp/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/quizapp/merges",
    archive_url: "https://api.github.com/repos/maqbull/quizapp/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/quizapp/downloads",
    issues_url: "https://api.github.com/repos/maqbull/quizapp/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/quizapp/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/quizapp/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/quizapp/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/quizapp/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/quizapp/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/quizapp/deployments",
    created_at: "2020-12-16T15:33:07Z",
    updated_at: "2020-12-16T16:26:24Z",
    pushed_at: "2020-12-16T16:26:20Z",
    git_url: "git://github.com/maqbull/quizapp.git",
    ssh_url: "git@github.com:maqbull/quizapp.git",
    clone_url: "https://github.com/maqbull/quizapp.git",
    svn_url: "https://github.com/maqbull/quizapp",
    homepage: null,
    size: 30309,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master"
    },
    {
    id: 346317153,
    node_id: "MDEwOlJlcG9zaXRvcnkzNDYzMTcxNTM=",
    name: "Shopper",
    full_name: "maqbull/Shopper",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/Shopper",
    description: "Basic React JS based shopping website",
    fork: false,
    url: "https://api.github.com/repos/maqbull/Shopper",
    forks_url: "https://api.github.com/repos/maqbull/Shopper/forks",
    keys_url: "https://api.github.com/repos/maqbull/Shopper/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/Shopper/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/Shopper/teams",
    hooks_url: "https://api.github.com/repos/maqbull/Shopper/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/Shopper/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/Shopper/events",
    assignees_url: "https://api.github.com/repos/maqbull/Shopper/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/Shopper/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/Shopper/tags",
    blobs_url: "https://api.github.com/repos/maqbull/Shopper/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/Shopper/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/Shopper/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/Shopper/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/Shopper/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/Shopper/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/Shopper/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/Shopper/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/Shopper/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/Shopper/subscription",
    commits_url: "https://api.github.com/repos/maqbull/Shopper/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/Shopper/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/Shopper/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/Shopper/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/Shopper/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/Shopper/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/Shopper/merges",
    archive_url: "https://api.github.com/repos/maqbull/Shopper/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/Shopper/downloads",
    issues_url: "https://api.github.com/repos/maqbull/Shopper/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/Shopper/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/Shopper/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/Shopper/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/Shopper/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/Shopper/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/Shopper/deployments",
    created_at: "2021-03-10T10:29:15Z",
    updated_at: "2021-03-10T10:39:29Z",
    pushed_at: "2021-03-10T10:33:48Z",
    git_url: "git://github.com/maqbull/Shopper.git",
    ssh_url: "git@github.com:maqbull/Shopper.git",
    clone_url: "https://github.com/maqbull/Shopper.git",
    svn_url: "https://github.com/maqbull/Shopper",
    homepage: "https://maqbull.github.io/Shopper",
    size: 579,
    stargazers_count: 1,
    watchers_count: 1,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 1,
    default_branch: "master"
    },
    {
    id: 274752274,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzQ3NTIyNzQ=",
    name: "signup.github.io",
    full_name: "maqbull/signup.github.io",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/signup.github.io",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/maqbull/signup.github.io",
    forks_url: "https://api.github.com/repos/maqbull/signup.github.io/forks",
    keys_url: "https://api.github.com/repos/maqbull/signup.github.io/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/signup.github.io/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/signup.github.io/teams",
    hooks_url: "https://api.github.com/repos/maqbull/signup.github.io/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/signup.github.io/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/signup.github.io/events",
    assignees_url: "https://api.github.com/repos/maqbull/signup.github.io/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/signup.github.io/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/signup.github.io/tags",
    blobs_url: "https://api.github.com/repos/maqbull/signup.github.io/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/signup.github.io/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/signup.github.io/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/signup.github.io/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/signup.github.io/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/signup.github.io/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/signup.github.io/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/signup.github.io/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/signup.github.io/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/signup.github.io/subscription",
    commits_url: "https://api.github.com/repos/maqbull/signup.github.io/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/signup.github.io/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/signup.github.io/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/signup.github.io/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/signup.github.io/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/signup.github.io/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/signup.github.io/merges",
    archive_url: "https://api.github.com/repos/maqbull/signup.github.io/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/signup.github.io/downloads",
    issues_url: "https://api.github.com/repos/maqbull/signup.github.io/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/signup.github.io/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/signup.github.io/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/signup.github.io/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/signup.github.io/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/signup.github.io/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/signup.github.io/deployments",
    created_at: "2020-06-24T19:26:59Z",
    updated_at: "2020-06-24T19:32:55Z",
    pushed_at: "2020-06-24T19:31:58Z",
    git_url: "git://github.com/maqbull/signup.github.io.git",
    ssh_url: "git@github.com:maqbull/signup.github.io.git",
    clone_url: "https://github.com/maqbull/signup.github.io.git",
    svn_url: "https://github.com/maqbull/signup.github.io",
    homepage: null,
    size: 20098,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master"
    },
    {
    id: 322021745,
    node_id: "MDEwOlJlcG9zaXRvcnkzMjIwMjE3NDU=",
    name: "stockdetail",
    full_name: "maqbull/stockdetail",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/stockdetail",
    description: "It will give u data about specific Stock",
    fork: false,
    url: "https://api.github.com/repos/maqbull/stockdetail",
    forks_url: "https://api.github.com/repos/maqbull/stockdetail/forks",
    keys_url: "https://api.github.com/repos/maqbull/stockdetail/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/stockdetail/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/stockdetail/teams",
    hooks_url: "https://api.github.com/repos/maqbull/stockdetail/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/stockdetail/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/stockdetail/events",
    assignees_url: "https://api.github.com/repos/maqbull/stockdetail/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/stockdetail/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/stockdetail/tags",
    blobs_url: "https://api.github.com/repos/maqbull/stockdetail/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/stockdetail/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/stockdetail/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/stockdetail/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/stockdetail/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/stockdetail/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/stockdetail/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/stockdetail/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/stockdetail/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/stockdetail/subscription",
    commits_url: "https://api.github.com/repos/maqbull/stockdetail/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/stockdetail/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/stockdetail/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/stockdetail/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/stockdetail/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/stockdetail/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/stockdetail/merges",
    archive_url: "https://api.github.com/repos/maqbull/stockdetail/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/stockdetail/downloads",
    issues_url: "https://api.github.com/repos/maqbull/stockdetail/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/stockdetail/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/stockdetail/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/stockdetail/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/stockdetail/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/stockdetail/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/stockdetail/deployments",
    created_at: "2020-12-16T15:21:33Z",
    updated_at: "2021-04-21T21:31:49Z",
    pushed_at: "2020-12-16T15:24:09Z",
    git_url: "git://github.com/maqbull/stockdetail.git",
    ssh_url: "git@github.com:maqbull/stockdetail.git",
    clone_url: "https://github.com/maqbull/stockdetail.git",
    svn_url: "https://github.com/maqbull/stockdetail",
    homepage: null,
    size: 3,
    stargazers_count: 2,
    watchers_count: 2,
    language: "Jupyter Notebook",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 2,
    default_branch: "main"
    },
    {
    id: 322023114,
    node_id: "MDEwOlJlcG9zaXRvcnkzMjIwMjMxMTQ=",
    name: "stockdetail_from_Nse",
    full_name: "maqbull/stockdetail_from_Nse",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/stockdetail_from_Nse",
    description: "stock detail from nse",
    fork: false,
    url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse",
    forks_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/forks",
    keys_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/teams",
    hooks_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/events",
    assignees_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/tags",
    blobs_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/subscription",
    commits_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/merges",
    archive_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/downloads",
    issues_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/stockdetail_from_Nse/deployments",
    created_at: "2020-12-16T15:26:33Z",
    updated_at: "2021-03-08T12:59:54Z",
    pushed_at: "2020-12-16T15:27:33Z",
    git_url: "git://github.com/maqbull/stockdetail_from_Nse.git",
    ssh_url: "git@github.com:maqbull/stockdetail_from_Nse.git",
    clone_url: "https://github.com/maqbull/stockdetail_from_Nse.git",
    svn_url: "https://github.com/maqbull/stockdetail_from_Nse",
    homepage: null,
    size: 3,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Jupyter Notebook",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "main"
    },
    {
    id: 332471092,
    node_id: "MDEwOlJlcG9zaXRvcnkzMzI0NzEwOTI=",
    name: "ubunturdp",
    full_name: "maqbull/ubunturdp",
    private: false,
    owner: {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false
    },
    html_url: "https://github.com/maqbull/ubunturdp",
    description: "A way to run Ubuntu on Github actions using Google remote desktop ",
    fork: true,
    url: "https://api.github.com/repos/maqbull/ubunturdp",
    forks_url: "https://api.github.com/repos/maqbull/ubunturdp/forks",
    keys_url: "https://api.github.com/repos/maqbull/ubunturdp/keys{/key_id}",
    collaborators_url: "https://api.github.com/repos/maqbull/ubunturdp/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/maqbull/ubunturdp/teams",
    hooks_url: "https://api.github.com/repos/maqbull/ubunturdp/hooks",
    issue_events_url: "https://api.github.com/repos/maqbull/ubunturdp/issues/events{/number}",
    events_url: "https://api.github.com/repos/maqbull/ubunturdp/events",
    assignees_url: "https://api.github.com/repos/maqbull/ubunturdp/assignees{/user}",
    branches_url: "https://api.github.com/repos/maqbull/ubunturdp/branches{/branch}",
    tags_url: "https://api.github.com/repos/maqbull/ubunturdp/tags",
    blobs_url: "https://api.github.com/repos/maqbull/ubunturdp/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/maqbull/ubunturdp/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/maqbull/ubunturdp/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/maqbull/ubunturdp/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/maqbull/ubunturdp/statuses/{sha}",
    languages_url: "https://api.github.com/repos/maqbull/ubunturdp/languages",
    stargazers_url: "https://api.github.com/repos/maqbull/ubunturdp/stargazers",
    contributors_url: "https://api.github.com/repos/maqbull/ubunturdp/contributors",
    subscribers_url: "https://api.github.com/repos/maqbull/ubunturdp/subscribers",
    subscription_url: "https://api.github.com/repos/maqbull/ubunturdp/subscription",
    commits_url: "https://api.github.com/repos/maqbull/ubunturdp/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/maqbull/ubunturdp/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/maqbull/ubunturdp/comments{/number}",
    issue_comment_url: "https://api.github.com/repos/maqbull/ubunturdp/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/maqbull/ubunturdp/contents/{+path}",
    compare_url: "https://api.github.com/repos/maqbull/ubunturdp/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/maqbull/ubunturdp/merges",
    archive_url: "https://api.github.com/repos/maqbull/ubunturdp/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/maqbull/ubunturdp/downloads",
    issues_url: "https://api.github.com/repos/maqbull/ubunturdp/issues{/number}",
    pulls_url: "https://api.github.com/repos/maqbull/ubunturdp/pulls{/number}",
    milestones_url: "https://api.github.com/repos/maqbull/ubunturdp/milestones{/number}",
    notifications_url: "https://api.github.com/repos/maqbull/ubunturdp/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/maqbull/ubunturdp/labels{/name}",
    releases_url: "https://api.github.com/repos/maqbull/ubunturdp/releases{/id}",
    deployments_url: "https://api.github.com/repos/maqbull/ubunturdp/deployments",
    created_at: "2021-01-24T14:32:06Z",
    updated_at: "2021-01-24T14:32:08Z",
    pushed_at: "2021-01-24T08:43:08Z",
    git_url: "git://github.com/maqbull/ubunturdp.git",
    ssh_url: "git@github.com:maqbull/ubunturdp.git",
    clone_url: "https://github.com/maqbull/ubunturdp.git",
    svn_url: "https://github.com/maqbull/ubunturdp",
    homepage: "",
    size: 1375,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
    key: "gpl-3.0",
    name: "GNU General Public License v3.0",
    spdx_id: "GPL-3.0",
    url: "https://api.github.com/licenses/gpl-3.0",
    node_id: "MDc6TGljZW5zZTk="
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main"
    }
    ]